import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { ISupplier } from '../models/Supplier';
import useApiHelper from '../hooks/useApiHelper';


export default function useSingleSupplier(supplierId: string) {
  const { get, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const supplier = useQuery({
    queryKey: ["supplier", supplierId],
    queryFn: () => get<ISupplier>(`/supplier/${supplierId}`),
  });

  const update = useMutation(
    (supplier: any) => put(`/supplier/${supplier.id}`, supplier),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["suppliers"]);
      },
    }
  );

  const remove = useMutation(
    (supplierId: string) => del(`/supplier/${supplierId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["suppliers"]);
      },
    }
  );

  return {
    supplier,
    update,
    remove
  };
}